import { render, staticRenderFns } from "./Health.vue?vue&type=template&id=45803773&scoped=true&"
import script from "./Health.vue?vue&type=script&lang=ts&"
export * from "./Health.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45803773",
  null
  
)

export default component.exports